import { defineStore } from "pinia";
import state from "./state";
import actions from "./actions";

export const useGlobalStore = defineStore("global", {
  state,
  actions: actions(),
});
